<template>
  <v-card-title>
    <v-container class="pa-12">
      <v-card class="pl-16 pr-16 pt-8 pb-16">
        <v-card-title>
          <v-row>
            <v-col cols="6" md="6" justify="center">
              <h3>Add Credit Note</h3>
            </v-col>
            <v-col cols="6" md="6">
              <v-row justify="end" class="mt-1">
                <!--  v-if="datainv_disable" -->
                <v-btn depressed class="mx-2" color="blue darken-1" outlined @click="getPrintOutData()">
                  Print Credit Note
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-card-title>
        <v-row class="row1 mt-3  pt-3 ">
          <v-col cols="12" md="5">
            <v-text-field v-model="showinv_no" single-line hide-details outlined dense disabled
              label="Invoice No."></v-text-field>
          </v-col>
          <v-col cols="12" md="1"></v-col>
          <v-col cols="12" md="5">
            <v-text-field v-model="showamount" single-line hide-details outlined dense disabled
              label="Amount"></v-text-field>
          </v-col>
        </v-row>
        <v-row class="row1 mt-3  pt-3 ">
          <v-col cols="12" md="5">
            <v-autocomplete v-model="customer_code" :items="customer" item-text="cust_account" item-value="id" outlined
              @change="showCode" disabled dense label="Client Code"></v-autocomplete>
          </v-col>
          <v-col cols="12" md="1"></v-col>
          <v-col cols="12" md="5">
            <v-autocomplete v-model="cus_id" :items="customerNameList" item-text="name" item-value="id" outlined dense
              disabled label="Client Name" v-on:change="showCusName"></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="row1 mt-3  pt-3 ">
          <v-col cols="12" md="5">
            <v-text-field v-model="vat_type_show" single-line hide-details outlined dense disabled
              label="Vat Type"></v-text-field>
          </v-col>
          <v-col cols="12" md="1"></v-col>
          <v-col cols="12" md="5">
            <v-textarea v-model="addIteminv_h.period_cover" single-line hide-details outlined dense rows="2"
              label="Reason CN"></v-textarea>
          </v-col>
        </v-row>

        <template>
          <template>
            <v-data-table :headers="headers" :items="desserts" sort-by="calories" class="elevation-1 ">
              <template v-slot:top>
                <v-toolbar flat>
                  <!-- <v-divider class="mx-4" inset vertical></v-divider>
                      <v-spacer></v-spacer> -->
                  <v-dialog v-model="dialog" max-width="500px">
                    <!-- <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="primary"
                            dark
                            class="mb-2"
                            v-bind="attrs"
                            v-on="on"
                          >
                            New Item
                          </v-btn>
                        </template> -->
                  </v-dialog>
                  <v-dialog v-model="dialogDelete" max-width="500px">
                    <v-card>
                      <v-card-title class="text-h5">Are you sure you want to delete this
                        item?</v-card-title>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="closeDeletefrom">Cancel</v-btn>
                        <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>

              <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">
                  Reset
                </v-btn>
              </template>
              <template v-slot:item.actions="{ item }" v-if="!disabledstatus">
                <!-- <v-icon small class="mr-2" @click="editItem(item)">
                      mdi-pencil
                    </v-icon> -->

                <v-btn @click="deleteItem(item)" :style="{
                  backgroundColor: '#9E3B1B',
                  color: 'white',
                }">
                  <v-icon small>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </template>

          <div class="pl-2 pr-2 pt-2 elevation-1 heightsize55formadvance" v-if="!disabledstatus">
            <template>
              <v-row>
                <v-col cols="12" xl="1" lg="1" md="1" sm="1"></v-col>
                <v-col cols="12" xl="4" lg="4" md="4" sm="4">
                  <v-text-field v-model="editedItem.description" ref="txtDescription" dense outlined
                    label="Description"></v-text-field>
                </v-col>
                <v-col cols="12" xl="2" lg="2" md="2" sm="2">
                  <v-text-field v-model="editedItem.unit" ref="txtunit" label="Qty" type="number" min="0" dense
                    outlined></v-text-field>
                </v-col>
                <v-col cols="12" xl="2" lg="2" md="2" sm="2">
                  <v-text-field v-model="editedItem.priceperunit" ref="txtPricePerUnit" label="Price per Unit"
                    type="number" min="0" dense outlined @keydown.tab="save()" @keydown.enter="save()"></v-text-field>
                </v-col>
                <v-col cols="12" xl="3" lg="3" md="3" sm="3"></v-col>
              </v-row>
            </template>
          </div>
        </template>

        <br />
        <v-row class="heightsize55formadvance">
          <v-col class="text-right" cols="12" md="7"> </v-col>
          <v-col class="text-right" cols="12" md="2">Total </v-col>
          <v-col class="text-right" cols="12" md="3">
            <v-row>
              <v-col cols="12" md="12">
                <v-row>
                  <v-col class="text-right" cols="12" md="10">
                    <v-text-field reverse filled disabled outlined dense v-model="sumtotal"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="heightsize55formadvance">
          <v-col class="text-right" cols="12" md="7"> </v-col>
          <v-col class="text-right" cols="12" md="2">VAT ({{ vat }}%) </v-col>
          <v-col class="text-right" cols="12" md="3">
            <v-row>
              <v-col cols="12" md="12">
                <v-row>
                  <v-col class="text-right" cols="12" md="10">
                    <v-text-field reverse filled disabled outlined dense v-model="vatCalSum"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row class="heightsize55formadvance">
          <v-col class="text-right" cols="12" md="7"> </v-col>
          <v-col class="text-right" cols="12" md="2">Grand total </v-col>
          <v-col class="text-right" cols="12" md="3">
            <v-row>
              <v-col cols="12" md="12">
                <v-row>
                  <v-col class="text-right" cols="12" md="10">
                    <v-text-field reverse filled disabled outlined dense v-model="sumGrandTotal"
                      class="text-right"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <br />
        <hr />
        <br />
        <div>
          <v-row>
            <v-col align="center" cols="12" md="12">
              <v-btn v-if="!disabledstatus" class="mr-5 buttonblue" color="#689ADE"
                @click="saveinvDraftandSubmit('Draft')">
                Draft
              </v-btn>
              <v-btn v-if="!disabledstatus" depressed @click="saveinvDraftandSubmit('Submit')" class="mr-5 buttonblue">
                Submit
              </v-btn>
              <v-btn depressed @click="$router.back()" class="mr-5" style="
                  background-color: #9e3b1b;
                  color: white;
                ">
                Cancel
              </v-btn>
            </v-col>
          </v-row>

          <!-- <v-row>
                <v-col align="end" cols="12" md="12">
                  <v-btn depressed class="buttonred">
                    Delete form
                  </v-btn>
                </v-col>
              </v-row> -->
        </div>
      </v-card>

      <v-dialog v-model="dialogSendMail" max-width="500px">
        <v-card>
          <v-card-title class="text-h6">Information Saved</v-card-title>
          <v-card-subtitle>
            บันทึกข้อมูลและส่งอีเมล์ถึงผู้อนุมัติสำเร็จ
          </v-card-subtitle>
          <v-card-actions>
            <v-spacer></v-spacer>
            <!-- <v-btn color="blue darken-1" text @click="closeDeleteForm"
                  >Cancel</v-btn
                > -->
            <v-btn color="blue darken-1" text @click="closeDialogSendmail()">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogSaveDraft" max-width="30%">
        <v-card>
          <v-card-title primary-title class="justify-center">
            {{ this.messageSaveDraft }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <!-- <v-btn color="blue darken-1" text @click="closeSaveDraft"
                              >Cancel</v-btn
                            > -->
            <v-btn color="blue darken-1" text @click="closeSaveDraft">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogDeleteimage" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDeleteimage">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="removeimage">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- print cn start  -->
      <template>
        <!-- 
            v-for="index in datashowAll.length"
            v-if="datashowAll.length >= 0 || pageAll >= 0" -->
        <!--   :style="showprint" -->
        <div v-if="false" id="mydivhtmltobase" :style="showprint">
          <page size="A4" class="aligncenter fontweight700" v-for="index in datashowAll.length">
            <div class="aligncenter">
              <!-- <div class="rowprpo ">
                    <div class="col-md-6report"></div>
                    <div class="col-md-6report">
                      <p class="alignright  colprpo mr30prpo mt30">
                        Page : {{ index }}
                      </p>
                    </div>
                  </div> -->

              <div class="rowprpo mr30prpo mt30">
                <div class="col-md-8report"></div>
                <div class="col-md-4report">
                  <h5 class="alignright colprpo ">
                    No : {{ print_header.inv_id }}
                  </h5>
                </div>
              </div>
              <div class="rowprpo aligncenter ">
                <div class="col-md-12report mt-30prpo">
                  <h3>
                    {{ print_header.com_title }}
                  </h3>
                </div>
              </div>
              <div class="rowprpo aligncenter ">
                <div class="col-md-12report ">
                  <h3>
                    {{ print_header.com_eng_1 }}
                  </h3>
                </div>
              </div>
              <div class="rowprpo  aligncenter fontsize10">
                <div class="col-md-12report">
                  {{ print_header.com_eng_2 }}
                </div>
              </div>
              <div class="rowprpo  aligncenter col-md-12report fontsize14">
                <div class="col-md-12report">
                  <h4>
                    {{ print_header.com_thai }}
                  </h4>
                </div>
              </div>
              <div class="rowprpo  aligncenter col-md-12report fontsize10">
                <div class="col-md-12report">
                  <h4>
                    {{ print_header.com_add_name }}
                  </h4>
                </div>
              </div>
              <div class="rowprpo  aligncenter col-md-12report fontsize10">
                <div class="col-md-12report">
                  <h4>
                    {{ print_header.com_add_no }}
                  </h4>
                </div>
              </div>
              <div class="rowprpo  aligncenter col-md-12report fontsize10">
                <div class="col-md-12report">
                  <h4>
                    {{ print_header.com_add_city }}
                  </h4>
                </div>
              </div>
              <div class="rowprpo  aligncenter col-md-12report fontsize10">
                <div class="col-md-12report">
                  <h4>
                    {{ print_header.com_add_country }}
                  </h4>
                </div>
              </div>
              <div class="rowprpo  aligncenter col-md-12report fontsize10">
                <div class="col-md-12report">
                  <h4>
                    {{ print_header.com_add_tel }}
                  </h4>
                </div>
              </div>
              <div class="rowprpo  aligncenter col-md-12report fontsize10">
                <div class="col-md-12report">
                  <h4>
                    {{ print_header.com_add_email }}
                  </h4>
                </div>
              </div>
              <div class="rowprpo  aligncenter col-md-12report fontsize10">
                <div class="col-md-12report">
                  <h5>
                    {{
                      print_header.com_add_tax_id
                        ? print_header.com_add_tax_id
                        : "-"
                    }}
                  </h5>
                </div>
              </div>
              <div class="rowprpo ml30prpo mr30prpo  aligncenter col-md-12report fontsize13">
                <v-divider style="margin-top: 5px;" class="borderwidththin"></v-divider>
              </div>
              <div class="rowprpo ml30prpo mr30prpo  aligncenter col-md-12report fontsize13">
                <div class="col-md-1report textalignleft ">
                  To/ถึง :
                </div>
                <div class="col-md-6report textalignleft fixonerow">
                  {{
                    print_header.customer_name
                      ? print_header.customer_name
                      : "-"
                  }}
                </div>
                <div class="col-md-4report textalignleft fontsize13">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Date/วันที่ :
                  {{
                    print_header.invoice_date ? print_header.invoice_date : "-"
                  }}
                </div>
              </div>
              <div class="rowprpo ml30prpo mr30prpo  aligncenter col-md-12report fontsize13 mt-5prpo">
                <div class="col-md-1report">
                  <h5></h5>
                </div>
                <div class="col-md-5report textalignleft fixthreerow">
                  {{ print_header.addressall ? print_header.addressall : "-" }}
                </div>
                <div class="col-md-1report"></div>
                <div class="col-md-3report textalignright">
                  Invoice Ref. / อ้างอิงใบแจ้งหนี้ :
                </div>
                <div class="col-md-2report textalignleft fixonerow">
                  &nbsp;
                  {{
                    print_header.period_cover ? print_header.period_cover : "-"
                  }}
                </div>
              </div>

              <!-- <div
                  class="rowprpo ml30prpo mr30prpo  aligncenter col-md-12report fontsize13"
                >
                  <div class="col-md-2report textalignleft">
                    Attention :
                  </div>
                  <div
                    class="col-md-6report textalignleft  ml-40prpo fixonerow"
                  >
                    {{
                      print_header.customer_contact_name
                        ? print_header.customer_contact_name
                        : "-"
                    }}
                  </div>
                  <div class="col-md-2report">
                    <h5></h5>
                  </div>
                  <div class="col-md-2report textalignleft">
                    <h5></h5>
                  </div>
                </div> -->
              <!-- <div
                class="rowprpo ml30prpo mr30prpo  aligncenter col-md-12report fontsize13 mt-5prpo"
              >
                <div class="col-md-1report textalignleft"></div>
                <div class="col-md-6report textalignleft fixonerow">
                  {{
                    print_header.province_invoice
                      ? print_header.province_invoice
                      : "-"
                  }}
                  ,
                  {{
                    print_header.zipcode_invoice
                      ? print_header.zipcode_invoice
                      : "-"
                  }}
                </div>
                <div class="col-md-2report">
                  <h5></h5>
                </div>
                <div class="col-md-2report textalignleft">
                  <h5></h5>
                </div>
              </div>
              <div
                class="rowprpo ml30prpo mr30prpo  aligncenter col-md-12report fontsize13 mt-5prpo"
              >
                <div class="col-md-1report textalignleft"></div>
                <div class="col-md-6report textalignleft fixonerow">
                  {{
                    print_header.country_invoice
                      ? print_header.country_invoice
                      : "-"
                  }}
                </div>
                <div class="col-md-2report">
                  <h5></h5>
                </div>
                <div class="col-md-2report textalignleft">
                  <h5></h5>
                </div>
              </div>
              -->

              <div class="rowprpo ml30prpo mr30prpo  aligncenter col-md-12report fontsize13 mt-5prpo">
                <div class="col-md-1report textalignleft">
                  TAX ID :
                </div>
                <div class="col-md-6report textalignleft fixonerow">
                  {{
                    print_header.customer_taxid
                      ? print_header.customer_taxid
                      : "-"
                  }}
                </div>
                <div class="col-md-2report">
                  <h5></h5>
                </div>
                <div class="col-md-3report textalignleft">
                  <h5></h5>
                </div>
              </div>
              <div class="rowprpo ml30prpo mr30prpo  aligncenter col-md-12report fontsize13">
                <v-divider style="margin-top: 5px;" class="borderwidththin"></v-divider>
              </div>
            </div>

            <div class="rowprpo caption  ml30prpo mr30prpo" style="margin-top:10px">
              <table class="captionhtable ">
                <tr>
                  <th scope="colgroup"
                    class="prbordertop2pxhtable prborderbottom2pxhtable width40 thborder-top thborder-left fontsize13 captionhtable">
                    <span class="aligncenter fontweight700">Description / รายการ
                    </span>
                  </th>
                  <th scope="colgroup"
                    class="prbordertop2pxhtable prborderbottom2pxhtable width10 thborder-top thborder-left thborder-right fontsize13 captionhtable">
                    <span class="aligncenter fontweight700">Amount / จำนวนเงิน
                    </span>
                  </th>
                </tr>
              </table>

              <table class="captionhtable " style="height:490px;">
                <tr v-for="(data, i) in datashowAll[index - 1]" style="height:20px;">
                  <td style="position: relative;" scope="colgroup"
                    class="textalignleft width80 caption prborderbottomsumpo tdborder-left fontsize13 paddingleftintable paddingrightintable">
                    <!-- <span
                      class="fixonerow fontsize13"
                      v-if="data.first_item == 1"
                    >
                      <span
                        class="titledatadetailintable"
                        v-if="data.report_type == 'SO'"
                        >Sales Order</span
                      >
                      <span
                        class="titledatadetailintable"
                        v-else-if="data.report_type == 'AD'"
                        >Advance</span
                      >
                      <span
                        class="titledatadetailintable"
                        v-else-if="data.report_type == 'MIS'"
                        >Miscellaneous</span
                      >
                    </span> -->
                    <span class="textalignleft fontweight700">
                      {{ data.report_desc }}</span>
                  </td>
                  <td style="position: relative;"
                    class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-right fontsize13">
                    <span class="width100 textalignright paddingrightintable fontweight700"
                      style="vertical-align: top;position:absolute;top:0px;">
                      <!-- <span
                        class="fixonerow fontsize13"
                        v-if="data.first_item == 1"
                        ><br />
                      </span> -->
                      <span v-if="data.report_amount > 0">
                        {{
                          data.report_amount.toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        }}
                      </span>
                    </span>
                  </td>
                </tr>
                <tr>
                  <td scope="colgroup"
                    class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-bottom"></td>
                  <td scope="colgroup"
                    class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-right tdborder-bottom">
                  </td>
                </tr>
              </table>
            </div>
            <div class="footerprpo">
              <div class="rowprpo caption  ml30prpo mr30prpo">
                <table class="captionhtable " v-if="index == datashowAll.length">
                  <tr>
                    <td scope="colgroup"
                      class="textalignleft  caption prborderbottomsumpo tdborder-left   width80 tdborder-bottom paddingleftintable">
                      <h4 class="textalignleft">
                        <span> Sub Total / รวมเป็นเงิน</span>
                      </h4>
                    </td>
                    <td scope="colgroup"
                      class="textalignleft  caption prborderbottomsumpo tdborder-left   width20 tdborder-right tdborder-bottom paddingrightintable">
                      <span class="textalignright">
                        <h4>
                          {{
                            print_header.sub_total
                              ? print_header.sub_total.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                              : "0.00"
                          }}
                        </h4>
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <td scope="colgroup"
                      class="textalignleft  caption prborderbottomsumpo tdborder-left   width80 tdborder-bottom paddingleftintable">
                      <h4 class="textalignleft">
                        <span>
                          Less Withholding Tax / ภาษีเงินได้ หัก ณ ที่จ่าย ({{
                            print_header.wth_rate
                              ? print_header.wth_rate
                              : "0.00"
                          }}
                          %)</span>
                      </h4>
                    </td>
                    <td scope="colgroup"
                      class="textalignleft  caption prborderbottomsumpo tdborder-left   width20 tdborder-right tdborder-bottom paddingrightintable">
                      <span class="textalignright">
                        <h4>
                          {{
                            print_header.wth_rate_amount
                              ? print_header.wth_rate_amount.toLocaleString(
                                "en-US",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )
                              : "0.00"
                          }}
                        </h4>
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <td scope="colgroup"
                      class="textalignleft width100 caption prborderbottomsumpo tdborder-left   tdborder-bottom paddingleftintable">
                      <h4>
                        <span class="textalignleft">
                          Value Added Tax / ภาษีมูลค่าเพิ่ม ({{
                            print_header.tax_rate
                              ? print_header.tax_rate
                              : "0.00"
                          }}
                          %)</span>
                      </h4>
                    </td>
                    <td scope="colgroup"
                      class="textalignleft width100 caption prborderbottomsumpo tdborder-left  tdborder-right tdborder-bottom paddingrightintable">
                      <span class="textalignright">
                        <h4>
                          {{
                            print_header.tax_rate_amount
                              ? print_header.tax_rate_amount.toLocaleString(
                                "en-US",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )
                              : "0.00"
                          }}
                        </h4>
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <td scope="colgroup"
                      class="textalignleft width100 caption prborderbottomsumpo tdborder-left   paddingleftintable">
                      <h4 class="textalignleft">
                        <span> Grand Total / ยอดรวม</span><br />
                        <!-- <span
                          class="fixonerowcenter"
                          style="background-color:#dedbdb;display: table;margin: 0px auto 0px auto;"
                          >({{ textamount_total_en }}) {{ currency_show }}</span
                        > -->
                      </h4>
                    </td>
                    <td scope="colgroup"
                      class="textalignleft width100 caption prborderbottomsumpo tdborder-left  tdborder-right tdborder-bottom paddingrightintable">
                      <span class="textalignright">
                        <h4>
                          {{
                            print_header.amount_total
                              ? print_header.amount_total.toLocaleString(
                                "en-US",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )
                              : "0.00"
                          }}
                        </h4>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2" scope="colgroup"
                      class="full-width-td textalignleft  paddingtoptintable fontsize14 caption prborderbottomsumpo tdborder-left tdborder-right tdborder-bottom   paddingleftintable mt-2">
                      <h4 class="textalignleft" v-if="check_cus_name">
                        <span class="fixonerowcenter"
                          style="background-color:#dedbdb;display: table;margin: 0px auto 0px auto;">({{
                            textamount_total_en }}) {{ currency_show }}</span>
                      </h4>
                      <h4 class="textalignleft" v-else>
                        <span v-if="currency_show != 'THB'" class="fixonerowcenter"
                          style="background-color:#dedbdb;display: table;margin: 0px auto 0px auto;">({{
                            textamount_total_en }}) {{ currency_show }}</span>
                        <span v-else class="fixonerowcenter"
                          style="background-color:#dedbdb;display: table;margin: 0px auto 0px auto;">({{
                            textamount_total_en }})</span>
                      </h4>
                    </td>
                  </tr>
                </table>

                <div class="rowprpo aligncenter mt30 fontweight700">
                  <div class="col-md-12report aligncenter">
                    <div class="aligncenter borderblack borderblockpr fontsize10 ">
                      <div class="  aligncenter col-md-12report mt20">
                        <div class="col-md-12report">
                          _________________________________________
                        </div>
                        <div class="col-md-12report">
                          Authorized Signature / ผู้มีอำนาจลงนาม
                        </div>
                        <div class="col-md-12report">
                          Date / วันที่ _____________________________
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="rowprpo  aligncenter col-md-12report fontsize10 fontweight700">
                  <div class="col-md-12report">
                    Please send us a certificate of above withholding income tax
                    issued to our firm together with your payment
                  </div>
                </div>
                <div class="rowprpo  aligncenter col-md-12report fontsize10 mt-5prpo fontweight700">
                  <div class="col-md-12report">
                    โปรดส่งหนังสือรับรองการหักภาษี ณ
                    ที่จ่ายมาพร้อมกับเอกสารชําระเงิน
                  </div>
                </div>
              </div>
            </div>
          </page>
          <page v-if="datashowAlltimesheet.length > 0" v-for="indextimesheet in datashowAlltimesheet.length" size="A4"
            class="aligncenter">
            <div class="aligncenter">
              <div class="rowprpo mr30prpo mt30">
                <div class="col-md-8report"></div>
                <div class="col-md-4report">
                  <h5 class="alignright colprpo ">
                    No : {{ print_header.inv_id }}
                  </h5>
                </div>
              </div>
              <div class="rowprpo aligncenter ">
                <div class="col-md-12report mt-30prpo">
                  <h3>
                    {{ print_header.com_title }}
                  </h3>
                </div>
              </div>
            </div>

            <div class="rowprpo caption  ml30prpo mr30prpo" style="margin-top:10px">
              <table class="captionhtable ">
                <tr>
                  <th scope="colgroup"
                    class="prbordertop2pxhtable prborderbottom2pxhtable width20 thborder-top thborder-left fontsize13 captionhtable">
                    <span class="aligncenter">Date / วันที่ </span>
                  </th>
                  <th scope="colgroup"
                    class="prbordertop2pxhtable prborderbottom2pxhtable width60 thborder-top thborder-left fontsize13 captionhtable">
                    <span class="aligncenter">Description / รายการ </span>
                  </th>
                  <th scope="colgroup"
                    class="prbordertop2pxhtable prborderbottom2pxhtable width20 thborder-top thborder-left thborder-right fontsize13 captionhtable">
                    <span class="aligncenter">Amount / จำนวนเงิน </span>
                  </th>
                </tr>
              </table>

              <table class="captionhtable " style="height:965px;">
                <tr v-for="(datatimsheet, itimsheet) in datashowAlltimesheet[
                  indextimesheet - 1
                ]" style="height:20px;">
                  <td style="position: relative;" scope="colgroup"
                    class="textalignleft width20 caption prborderbottomsumpo tdborder-left fontsize13">
                    <span class="width100 textalignleft" style="vertical-align: top;position:absolute;top:0px;">
                      {{ datatimsheet.report_date }}</span>
                  </td>
                  <td style="position: relative;" scope="colgroup"
                    class="textalignleft width60 caption prborderbottomsumpo tdborder-left  fontsize13">
                    <span class="textalignleft">
                      {{ datatimsheet.report_desc }}</span>
                  </td>
                  <td style="position: relative;"
                    class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-right fontsize13">
                    <span class="width100 textalignright" style="vertical-align: top;position:absolute;top:0px;">
                      {{
                        datatimsheet.report_amount.toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      }}</span>
                  </td>
                </tr>
                <tr>
                  <td scope="colgroup"
                    class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-bottom"></td>
                  <td scope="colgroup"
                    class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-bottom"></td>
                  <td scope="colgroup"
                    class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-right tdborder-bottom">
                  </td>
                </tr>
              </table>
            </div>
            <div class="footerprpo">
              <div class="rowprpo caption  ml30prpo mr30prpo">
                <div class="rowprpo  aligncenter col-md-12report fontsize10">
                  <div class="col-md-12report">
                    Please send us a certificate of above withholding income tax
                    issued to our firm together with your payment
                  </div>
                </div>
                <div class="rowprpo  aligncenter col-md-12report fontsize10 mt-5prpo">
                  <div class="col-md-12report">
                    โปรดส่งหนังสือรับรองการหักภาษี ณ
                    ที่จ่ายมาพร้อมกับเอกสารชําระเงิน
                  </div>
                </div>
              </div>
            </div>
          </page>
        </div>
      </template>

      <PdfPreviewDialog v-model="dialogPDF" :blob="pdfBlob" :filename="getFileName()" />

      <!-- print cn end  -->
      <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />

      <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message" :link="link" />
    </v-container>
  </v-card-title>
</template>

<script>
import api from "@/services/api";
import { server } from "@/services/constants";
import StockCard from "@/components/cards/StockCard";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import { imageUrl } from "@/services/constants";
import {
  tolocalestringnumber,
  stringcommatonumber,
} from "../computing/tolocalestringnumber";
import { language } from "../language/Leavelist.js";
import html2pdf from "html2pdf.js";
var convert = require("decimal-number-to-words");
import unity from "@/unity/unity";
import PdfPreviewDialog from "@/components/cards/PdfPreviewDialog";

export default {
  name: "NewAdvance",
  data() {
    return {
      pdfBlob: null,
      pdfObj: null,
      dialogPDF: false,
      datacompany: [],
      disabledstatus: false,
      dialog: false,
      customer_code: "",
      addIteminv_h: {
        inv_id: "",
        pinv_id: "",
        company_id: localStorage.getItem(server.COMPANYID),
        inv_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        period_cover: "",
        inv_type: "C",
        customerid: 0,
        customer_address: "",
        customer_taxid: "",
        customer_branch: "",
        customer_paymentterm: 0,
        customer_vat: 0,
        so_total: 0,
        ts_total: 0,
        ad_total: 0,
        mis_total: 0,
        sub_total: 0,
        wth_rate: 0,
        tax_rate: 0,
        amount_total: 0,
        status: 0,
        user_create: localStorage.getItem(server.USER_ID),
      },
      showinv_no: "",
      showinv_id: 0,
      showamount: 0,
      menu: false,
      menu2: false,
      os_h: {
        saleorder_id: "",
        customerid: 0,
        remark: "",
        po_no: "",
        po_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        delivery_date: new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10),
        additional: "",
        status: 0,
        image: "",
      },
      addinv_docref_cn: {
        inv_hid: 0,
        ref_type: "CN",
        ref_id: 0,
      },
      dialogDeleteimage: false,

      desserts: [
        {
          no: "1",
          detail: "",
          withdrawamount: 0,
        },
      ],
      headers: [
        {
          text: "No.",
          value: "no",
          class: "bg-colorth texttablehcenter ",
          width: "8%",
          align: "start",
          divider: true,
          sortable: false,
        },
        {
          text: "Service/Description",
          align: "center",
          value: "description",
          class: "bg-colorth texttablehcenter",
          width: "35%",
          align: "start",
          divider: true,
          sortable: false,
        },
        {
          text: "Qty",
          value: "unit",
          class: "bg-colorth texttablehcenter ",
          width: "15%",
          divider: true,
          align: "end",
          sortable: false,
        },

        {
          text: "Price Per Unit",
          value: "priceperunit",
          class: "bg-colorth texttablehcenter",
          width: "17%",
          divider: true,
          align: "end",
          sortable: false,
        },
        {
          text: "Amount",
          value: "amount",
          class: "bg-colorth texttablehcenter",
          width: "17%",
          divider: true,
          align: "end",
          sortable: false,
        },

        {
          value: "actions",
          class: "bg-colorth texttablehcenter",
          width: "8%",
          divider: true,
          sortable: false,
        },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        description: "",
        no: 0,
        unit: 0,
        amount: 0,
        priceperunit: 0,
      },
      defaultItem: {
        no: 0,
        description: "",
        amount: 0,
        unit: 0,
        priceperunit: 0,
      },
      advance_log: {
        module: "SO",
        module_id: 0,
        approve_id: 0,
        approve_status: 0,
        approve_date: null,
      },
      addinv_so: {
        inv_hid: 0,
        so_seq: 0,
        item_id: "",
        item_name: "",
        item_qty: 0,
        item_um: "",
        item_price: 0,
        item_disc: 0,
        item_line_amt: 0,
        user_create: localStorage.getItem(server.USER_ID),
      },
      lbl_date_request: false,
      dialogSignature: false,
      dialogSaveDraft: false,
      messageSaveDraft: "",
      currency_show: "",
      paymentType: "",
      bankName: "",
      bankNumber: "",
      chequeNumber: "",
      remark: "",
      sendMail: {
        name: "",
        email: "",
        advance_id: "",
        link: "",
      },
      account: {
        signature: "",
      },
      customerNameList: [],
      customerList: [
        {
          cust_account: "",
        },
      ],
      cus_id: 0,
      datePO: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dateDelivery: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      dateCurrent: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dialogDelete: false,
      no_cus: 0,
      sumtotal: 0.0,
      vatCal: 7,
      vatCalSum: 0.0,
      vat: "7.00",
      sumGrandTotal: 0.0,
      preview_list: [],
      image_list: [],
      dialogAdd: false,
      dialogSendMail: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      customer: [],

      //print va start
      showprint: "",
      textamount_total_en: "",
      dataformatpr: {
        headtitle: "Credit Note",
        title: "Dej-Udom & Associates LTD.",
        subtitle: "ATTORNEY AT LAW",
        paymenttype: "Payment Type",
        companyname_addressrow1:
          "เลขที่ 142 อาคาร ทู แปซิฟิค เพลส ชั้น20 ถนนสุขุมวิท แขวงคลองเตย",
        companyname_addressrow2: "เขตคลองเตย กรุงเทพฯ 10110",
        pr_number: "เลขที่ใบขอซื้อ/PR Number",
        pr_date: "วันที่/PR Date",
        companyname_tel: "โทรศัพท์/Tel. 02-6530489-9",
        companyname_fax: "โทรสาร/Fax. 02-6533706",
        prtitle_th: "ใบขอซื้อ",
        prtitle_en: "PURCHASE REQUISTION",
        titleth: "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
        address1: "CHARN ISSARA TOWER 9 FLOOR",
        address2: "942/69 RAMA IV ROAD,",
        address3: "KWAENG SURIYAWONG, KHET BANGRAK,",
        address4: "BANGKOK 10500, THAILAND",
        tel: "Tel : 0-2233-0055, 0-2267-5152",
        fax: "Fax : 0.2236-6681, 0-2233-0227",
        email: "E-MAIL:account@dejudom.com",
        taxid: 'TAX ID. No. 0105534015348 / "HEAD OFFICE"',
      },

      status: ["Draft", "P.Invoice", "Invoice", "Cancel"],
      datefrom: null,
      dateto: null,
      dateCurrent: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      seticonsearchmore: { icon: "mdi mdi-chevron-down", action: false },
      setlanguage: language.en,
      defaultlanguage: "en",
      // regexlang: "th",
      chooselanguage: [
        { name: "en", flag: "gb" },
        { name: "th", flag: "th" },
      ],
      aa: "สวัสดี",
      mDataArray: [
        {
          id: "97",
          date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10),
          customer: "testcus",
          status: "Draft",
        },
      ],
      position: [],
      approver: [],
      department: [],
      department_list: [],
      position_list: [],
      company: [],
      authorize: [],
      inv_id: 0,
      dialogPrintOutData: "1",
      print_header_list: [
        {
          id: "1",
          com_title: "Credit Note",
          com_eng_1: "DEJ-UDOM & ASSOCIATES LTD.",
          com_eng_2: "ATTORNEYS AT LAW",
          com_thai: "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
          com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
          com_add_no: "942/69 RAMA IV ROAD,",
          com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
          com_add_country: "BANGKOK 10500, THAILAND",
          com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
          com_add_email: "E-MAIL : account@dejudom.com",
          com_add_tax_id: `TAX ID. No. 0105534015348/"HEAD OFFICE"`,
        },
        {
          id: "2",
          com_title: "Credit Note",
          com_eng_1: "DEJ-UDOM & ASSOCIATES",
          com_eng_2: "ATTORNEYS AT LAW",
          com_thai: "สำนักกฎหมาย เดชอุดม แอนด์ แอสโซซิเอทส์",
          com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
          com_add_no: "942/69 RAMA IV ROAD,",
          com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
          com_add_country: "BANGKOK 10500, THAILAND",
          com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
          com_add_email: "E-MAIL : account@dejudom.com",
          com_add_tax_id: `TAX ID. No. 0992000028227`,
        },
      ],
      print_header: {},
      print_table_detail: [],
      pageAll: 1,
      opensummarize: false,
      datashowAll: [],
      setdatatoshow: [],
      dataforshowprpo: [],
      getheightcontentpr: 0,
      dialogPrintOutData: "1",
      dialogPrintOut: false,
      menu: false,
      menu2: false,
      search: "",
      toggleEnable: false,
      selectstatus: "",
      dataAll: [],
      setdatatoshow: [],
      dataforshowprpo: [],
      getheightcontentpr: 0,
      opensummarizetimesheet: false,
      pageAlltimesheet: 1,
      setdatatoshowtimesheet: [],
      print_table_detailtimesheet: [],
      datashowAlltimesheet: [],
      check_cus_name: false,
      //print va end
      vat_type: "",
      vat_type_show: "",
    };
  },
  components: {
    StockCard,
    SuccessDialog,
    SuccessDialogPush,
    PdfPreviewDialog,
  },
  computed: {
    version() {
      return this.initial_data;
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },

    // เพิ่มส่วนนี้ (Optional - เพื่อความสะดวกในการเข้าถึงข้อมูล)
    pdfHeader() {
      return this.main_data?.print_header || {};
    },

    pdfItems() {
      return this.extractItems();
    },

    pdfTextAmountEn() {
      return this.main_data?.textamount_total_en || "";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDeletefrom();
    },
  },

  async mounted() {

    this.$forceUpdate();

    this.loadCustomer();



    const userId = localStorage.getItem(server.USER_ID);
    if (userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }

    const result = await api.getAllCustomerListactiveCompany({
      params: {
        company_id: localStorage.getItem(server.COMPANYID),
      },
    });

    this.customer = result.data;

    // const resultlist = await api.getCustomers();
    // this.customerNameList = result.data[0];
    this.customerNameList = result.data;
    // await this.loaddatainv_h(this.$route.params.id);
    await this.loaddataEditCreditNote(this.$route.params.id);

    // เพิ่มส่วนนี้เพื่อเช็คว่า pdfMake พร้อมใช้งาน
    this.waitForPdfMakeReady()
      .then(() => {
        this.pdfMakeReady = true;

      })
      .catch((error) => {
        console.error("❌ เกิดข้อผิดพลาดในการโหลด pdfMake:", error);
      });

    this.$hideLoader();
  },
  methods: {
    getFileName() {
      return `Credit_Note_${this.print_header.inv_id ?? ''}.pdf`
    },
    //print start
    async loadRef_TypeCNById() {
      // const res_docref_so = await api.getRef_TypeCNById(this.inv_id);

      const res_hresult = await api.billing_expense_getdataByIdInvoice_H(this.inv_id);

      if (res_hresult.data[0].company_inv == "D") {
        this.print_header = this.print_header_list[0];
      } else if (res_hresult.data[0].company_inv == "L") {
        this.print_header = this.print_header_list[1];
      }

      this.print_header.inv_id = res_hresult.data[0].inv_id
        ? res_hresult.data[0].inv_id
        : res_hresult.data[0].pinv_id;

      this.print_header.invoice_date = res_hresult.data[0].date_show;

      this.print_header.sub_total = parseFloat(res_hresult.data[0].sub_total);
      this.print_header.wth_rate = parseFloat(res_hresult.data[0].wth_rate);
      this.print_header.tax_rate = parseFloat(res_hresult.data[0].tax_rate);
      this.print_header.wth_rate_amount = parseFloat(
        (res_hresult.data[0].sub_total * res_hresult.data[0].wth_rate) / 100
      );
      this.print_header.tax_rate_amount = parseFloat(
        (res_hresult.data[0].sub_total * res_hresult.data[0].tax_rate) / 100
      );

      this.print_header.amount_total = parseFloat(
        res_hresult.data[0].amount_total
      );

      // company L ไม่แสดง VAT -> Grand Total = Sub Total
      if (this.print_header.company_inv == "L") {
        this.print_header.tax_rate_amount = 0;
        this.print_header.amount_total = this.print_header.sub_total;
      }

      const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      let matches = this.print_header.customer_name.match(checker_th);
      // const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      if (matches) {
        this.check_cus_name = false;
      } else {
        this.check_cus_name = true;
      }

      if (this.check_cus_name) {
        this.textamount_total_en = convert.toWords(
          this.print_header.amount_total
        );
        let setcheckscratch = false;
        this.textamount_total_en = this.textamount_total_en.replace(
          /\b./g,
          function (m) {
            if (m == ",") {
              return "";
            }
            if (m == "-") {
              setcheckscratch = true;
              return m;
            } else {
              if (setcheckscratch) {
                setcheckscratch = false;
                return m;
              }
              setcheckscratch = false;
              return m.toUpperCase();
            }
          }
        );
      } else {

        //start เปลี่ยนเป็นตัวอ่านไทย
        // อาเรย์สำหรับแปลงตัวเลขเป็นข้อความไทย
        var thaiNumbers = [
          "",
          "หนึ่ง",
          "สอง",
          "สาม",
          "สี่",
          "ห้า",
          "หก",
          "เจ็ด",
          "แปด",
          "เก้า",
        ];
        var thaiUnits = ["", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน"];

        // แยกตัวจำนวนเต็มและทศนิยมห
        this.print_header.amount_total =
          Math.round(this.print_header.amount_total * 100) / 100;
        var [
          integerPart,
          decimalPart,
        ] = this.print_header.amount_total.toString().split(".");

        let de_check = 0;

        if (decimalPart) {
          if (decimalPart.split("").length == 1) {
            if (Number(decimalPart) >= 10) {
              decimalPart = decimalPart;
            } else if (Number(decimalPart) > 0) {
              decimalPart = Number(decimalPart) * 10;
            } else {
              de_check = 1;
            }
          }
        } else {
          de_check = 1;
        }
        let decimalText = "";
        if (de_check == 0) {
          decimalPart = String(decimalPart);

          let numArrays = decimalPart.split("").map(Number);
          numArrays.forEach((num, index) => {
            let units = thaiUnits[numArrays.length - index - 1];
            let digits = thaiNumbers[num];
            if (num !== 0) {
              if (num === 1 && index === numArrays.length - 1) {
                // ตรวจสอบว่าเป็นตำแหน่งสุดท้าย
                decimalText += "เอ็ด" + units;
              } else if (
                num === 2 &&
                index === numArrays.length - 2 &&
                numArrays.length >= 2
              ) {
                decimalText += "ยี่" + units;
              } else if (
                num === 1 &&
                index === numArrays.length - 2 &&
                numArrays.length >= 2
              ) {
                decimalText += units;
              } else {
                decimalText += digits + units;
              }
            }
          });

          decimalText = decimalText + "สตางค์";
        }

        // แปลงส่วนจำนวนเต็มเป็นข้อความไทย
        let integerText = "";

        let numArray = integerPart.split("").map(Number);
        numArray.forEach((num, index) => {
          let unit = thaiUnits[numArray.length - index - 1];
          let digit = thaiNumbers[num];
          if (num !== 0) {
            if (num === 1 && index === numArray.length - 1) {
              // ตรวจสอบว่าเป็นตำแหน่งสุดท้าย
              integerText += "เอ็ด" + unit;
            } else if (
              num === 2 &&
              index === numArray.length - 2 &&
              numArray.length >= 2
            ) {
              integerText += "ยี่" + unit;
            } else if (
              num === 1 &&
              index === numArray.length - 2 &&
              numArray.length >= 2
            ) {
              integerText += unit;
            } else {
              integerText += digit + unit;
            }
          }
        });

        integerText = integerText + "บาท";



        let result = "";
        result = integerText + decimalText;

        this.textamount_total_en = result;
      }
    },
    async loadInvSoData() {
      var tmp_inv_data;
      const res_inv_so = await api.billing_expense_printInvSO(this.inv_id);


      tmp_inv_data = res_inv_so.data;

      tmp_inv_data.forEach((inv_so, index) => {
        var data = {
          report_type: "SO",
          report_desc: "",
          report_amount: 0,
          first_item: 0,
        };
        if (index == 0) {
          data.first_item = 1;
        }

        data.report_desc = inv_so.report_desc;
        data.report_amount = parseFloat(inv_so.report_amount);
        this.print_table_detail.push(data);
      });
    },
    async loadMainInvSoData() {
      // var tmp_inv_data;
      const res_docref_so = await api.billing_expense_getRef_TypeCNById(this.inv_id);

      const res_inv_so = await api.billing_expense_getPrintDataByIdAndCusTypeInvoice_H(
        res_docref_so.data[0].ref_id
      );

      if (res_inv_so.data[0].company_inv == "D") {
        this.print_header = this.print_header_list[0];
      } else if (res_inv_so.data[0].company_inv == "L") {
        this.print_header = this.print_header_list[1];
      } else {
        const res_company = await api.getCompanyByID(Number(res_inv_so.data[0].company_inv));
        this.datacompany = res_company.data[0];
      }
      this.print_header.company_inv = res_inv_so.data[0].company_inv;
      this.currency_show = res_inv_so.data[0].currency;
      this.print_header.customer_name = res_inv_so.data[0].customer_name;
      // this.print_header.invoice_date = res_inv_so.data[0].date;
      this.print_header.addressall = res_inv_so.data[0].addressall;
      this.print_header.customer_address = res_inv_so.data[0].customer_address;

      this.print_header.province_invoice = res_inv_so.data[0].province_invoice;
      this.print_header.country_invoice = res_inv_so.data[0].country_invoice;
      this.print_header.zipcode_invoice = res_inv_so.data[0].zipcode_invoice;

      this.print_header.period_cover = res_inv_so.data[0].inv_id
        ? res_inv_so.data[0].inv_id
        : res_inv_so.data[0].pinv_id;
      this.print_header.customer_contact_name =
        res_inv_so.data[0].customer_contact_name;
      this.print_header.customer_taxid = res_inv_so.data[0].customer_taxid;
    },
    async checkcontent() {

      this.datashowAll = [];
      // alert(data.length);
      this.setdatatoshow = [];
      let linedetailprpo = 23;
      let datainlineprpo = 80;
      let addnewbutget = 1;
      let getdata = [];
      let getnewdata = [];
      let hllinedetails = 0;
      this.pageAll = 1;
      let newhllinedetails = 0;
      for (let i = 0; i < this.print_table_detail.length; i++) {
        let stringchecklength = "";
        let lengthofdataforshowprpo = this.print_table_detail[i].report_desc
          .length;

        let maiek = "่"; //ไม้เอก
        let maito = "้"; //ไม้โท
        let maitree = "๊"; //ไม้ตรี
        let maijattawa = "๋"; //ไม้จัตวา
        let vowelei = "ิ"; //สระอิ
        let vowelee = "ี"; //สระอี
        let voweleue = "ึ"; //สระอึ
        let voweleu = "ื"; //สระอือ
        let vowelu = "ุ"; //สระอุ
        let voweluu = "ู"; //สระอู
        let maihun = "ั"; //ไม้หันอากาศ
        let maiyamok = "็"; //ไม้เอก
        newhllinedetails = 0;
        getnewdata = [];
        this.print_table_detail[i].no = i + 1;

        for (
          let j = 0;
          j < this.print_table_detail[i].report_desc.length;
          j++
        ) {
          if (
            stringchecklength[j] == maiek ||
            stringchecklength[j] == maito ||
            stringchecklength[j] == maitree ||
            stringchecklength[j] == maijattawa ||
            stringchecklength[j] == vowelei ||
            stringchecklength[j] == vowelee ||
            stringchecklength[j] == voweleue ||
            stringchecklength[j] == voweleu ||
            stringchecklength[j] == vowelu ||
            stringchecklength[j] == voweluu ||
            stringchecklength[j] == maihun ||
            stringchecklength[j] == maiyamok
          ) {
            lengthofdataforshowprpo--;
          }
        }
        newhllinedetails = Math.ceil(lengthofdataforshowprpo / datainlineprpo);

        // if (this.print_table_detail[i].first_item == 1) {
        //   newhllinedetails++;
        // }

        // newhllinedetails = Math.ceil(
        //   this.print_table_detail[i].NAME.length / datainlineprpo
        // );

        // newhllinedetails += addnewbutget;
        getnewdata.push(this.print_table_detail[i]);

        if (hllinedetails + newhllinedetails > linedetailprpo) {

          this.setdatatoshow[this.pageAll - 1] = getdata;
          this.pageAll++;

          hllinedetails = 0;
          getdata = [];
          getdata.push(this.print_table_detail[i]);
          hllinedetails += newhllinedetails;
          if (i == this.print_table_detail.length - 1) {
            this.setdatatoshow[this.pageAll - 1] = getdata;
            getdata = [];
          }
        } else {
          hllinedetails += newhllinedetails;

          getdata.push(this.print_table_detail[i]);

          if (i == this.print_table_detail.length - 1) {
            this.setdatatoshow[this.pageAll - 1] = getdata;
            getdata = [];
          }
        }
      }
      this.opensummarize = true;


      this.setdatatoshow.forEach((item, iitem) => {

        if (iitem == this.setdatatoshow.length - 1) {
          item[this.setdatatoshow[iitem].length - 1].lastdata = "lastindex";
        }

        this.datashowAll.push(item);
      });

    },
    async exportToPDF(advance_id) {
      // this.$refs.html2Pdf.generatePdf();

      this.showprint = "";
      let element = document.getElementById("mydivhtmltobase");
      const opt = {
        margin: [0, 0, 0, 0],
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        // enableLinks: false,
        html2canvas: {
          scale: 2,
          dpi: 192,
          letterRendering: true,
          useCORS: true,
          // ignoreElements: (e) => {
          //   return e.classList.contains("cke_pagebreak") ||
          //     e.classList.contains("html2pdf__page-break")
          //     ? true
          //     : false;
          // },
        },
        jsPDF: {
          unit: "cm",
          format: "A4",
          orientation: "portrait",
          putOnlyUsedFonts: true,
          pagesplit: true,
        },
        // pagebreak: { mode: ["avoid-all"], after: ".cke_pagebreak" },
      };

      let abcd = await html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get("pdf")
        // .output("bloburl")
        .then(function (pdf) {

          const totalPages = pdf.internal.getNumberOfPages();
          pdf.deletePage(totalPages);
          return pdf.output("bloburl");
        });

      window.open(abcd);
      let blob = await fetch(abcd).then((r) => r.blob());
      this.showprint = "display:none;";

      return;
    },
    async getPrintOutData() {
      this.inv_id = this.$route.params.id;
      this.showprint = "";
      this.datashowAll = [];
      this.print_table_detail = [];
      this.dialogPrintOut = false;
      this.$showLoader();
      // await this.loadRef_TypeCNById();
      await this.loadInvSoData();
      await this.loadMainInvSoData();
      await this.loadRef_TypeCNById();
      await this.checkcontent();
      // await this.exportToPDF();
      await this.previewCreditNotePDF();


      this.$hideLoader();
    },

    // print end

    // ====================================================================
    // ฟังชั่นรอให้ pdfMake พร้อมใช้งาน
    // ====================================================================
    waitForPdfMakeReady() {
      return new Promise((resolve, reject) => {
        const checkInterval = setInterval(() => {
          if (typeof pdfMake !== "undefined" && pdfMake.vfs && pdfMake.fonts) {
            clearInterval(checkInterval);

            resolve(true);
          }
        }, 100);

        setTimeout(() => {
          clearInterval(checkInterval);
          reject(new Error("pdfMake โหลดไม่สำเร็จ"));
        }, 10000);
      });
    },

    // ====================================================================
    // ฟังชั่นจัดฟอร์แมตตัวเลข
    // ====================================================================
    formatNumber(value) {
      if (!value && value !== 0) return "0.00";
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },

    // ====================================================================
    // ฟังชั่นจัดฟอร์แมตวันที่
    // ====================================================================
    formatDate2(dateString) {


      if (!dateString) return "";
      if (dateString.includes("/")) {
        return dateString;
      }

      const date = new Date(dateString);
      const day = date
        .getDate()
        .toString()
        .padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },

    // ====================================================================
    // ฟังชั่นสร้าง Title และเลขที่เอกสาร (บนสุด)
    // ====================================================================
    createTopTitle(header) {
      return {
        columns: [
          {
            width: "50%",
            text: header.com_title || "CREDIT NOTE",
            fontSize: 20,
            bold: true,
            margin: [0, 0, 0, 15],
          },
          {
            width: "50%",
            text: `No. / เลขที่ : ${header.inv_id || "________"}`,
            fontSize: 10,
            alignment: "right",
            margin: [0, 5, 0, 15],
          },
        ],
      };
    },

    // ====================================================================
    // ฟังชั่นสร้าง Header ของเอกสาร
    // ====================================================================
    createHeader(header) {

      if (header.company_inv == "D") {
        header.com_eng_1 = header.com_eng_1 || "DEJ-UDOM & ASSOCIATES LTD.";
        header.com_eng_2 = header.com_eng_2 || "ATTORNEY AT LAW";
        header.com_thai = header.com_thai || "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด";
        header.com_add_name = "CHARN ISSARA TOWER 1, 2nd Floor, \n 942/69 RAMA IV ROAD,";
        header.com_add_city = `${header.com_add_city}` || "KWAENG SURIYAWONG, KHET BANGRAK,";
        header.com_add_country = `${header.com_add_country}` || "BANGKOK 10500, THAILAND";
        header.com_add_tel = `${header.com_add_tel}` || "Tel : 0-2233-0055, 0-2267-5152";
        header.com_add_email = `${header.com_add_email}` || "E-MAIL : account@dejudom.com";
        header.com_add_tax_id = `${header.com_add_tax_id}` || 'TAX ID. No. 0105534015348 / "HEAD OFFICE"';
      } else if (header.company_inv == "L") {
        header.com_eng_1 = header.com_eng_1 || "DEJ-UDOM & ASSOCIATES";
        header.com_eng_2 = header.com_eng_2 || "ATTORNEY AT LAW";
        header.com_thai = header.com_thai || "สำนักกฎหมาย เดชอุดม แอนด์ แอสโซซิเอทส์";
        header.com_add_name = "CHARN ISSARA TOWER 1, 2nd Floor, \n 942/69 RAMA IV ROAD,";
        header.com_add_city = `${header.com_add_city}` || "KWAENG SURIYAWONG, KHET BANGRAK,";
        header.com_add_country = `${header.com_add_country}` || "BANGKOK 10500, THAILAND";
        header.com_add_tel = `${header.com_add_tel}` || "Tel : 0-2233-0055, 0-2267-5152";
        header.com_add_email = `${header.com_add_email}` || "E-MAIL : account@dejudom.com";
        header.com_add_tax_id = `${header.com_add_tax_id}` || 'TAX ID. No. 0992000028227';
      } else {


        header.com_eng_1 = this.datacompany.inv_company_name;
        header.com_eng_2 = "";
        header.com_thai = this.datacompany.inv_company_name_th;
        header.com_add_name = `${this.datacompany.inv_company_address}, \n ${this.datacompany.inv_company_address2}`;
        if (this.datacompany.inv_company_address2 && this.datacompany.inv_company_address2 != "") {
          header.com_add_name = header.com_add_name + ",";
        }
        header.com_add_city = `${this.datacompany.inv_subdistrict}, ${this.datacompany.inv_subdistrict},`;
        header.com_add_country = `${this.datacompany.inv_province}, ${this.datacompany.inv_postcode}, ${this.datacompany.inv_country}`;
        header.com_add_tel = `Tel : ${this.datacompany.inv_company_tel}`;
        header.com_add_email = `E-MAIL : ${this.datacompany.inv_company_email}`;
        header.com_add_tax_id = `TAX ID. No. ${this.datacompany.inv_tax_id}/"${this.datacompany.inv_company_branch}"`;
      }

      return {
        columns: [
          // ส่วนซ้าย - ข้อมูลบริษัท
          {
            width: "50%",
            stack: [
              {
                text: header.com_eng_1,
                fontSize: 12,
                bold: true,
                margin: [0, 0, 0, 2],
              },
              {
                text: header.com_eng_2,
                fontSize: 9,
                bold: true,
                margin: [0, 0, 0, 2],
              },
              {
                text:
                  header.com_thai,
                fontSize: 9,
                bold: true,
                margin: [0, 0, 0, 2],
              },
            ],
          },
          // ส่วนขวา - ที่อยู่บริษัท
          {
            width: "50%",
            stack: [
              {
                text: header.com_add_name,
                fontSize: 8,
                alignment: "right",
                margin: [0, 0, 0, 2],
                bold: true,
              },
              {
                text:
                  header.com_add_city,
                fontSize: 8,
                alignment: "right",
                margin: [0, 0, 0, 2],
                bold: true,
              },
              {
                text:
                  header.com_add_country,
                fontSize: 8,
                alignment: "right",
                margin: [0, 0, 0, 2],
                bold: true,
              },
              {
                text: header.com_add_tel,
                fontSize: 8,
                alignment: "right",
                margin: [0, 0, 0, 2],
                bold: true,
              },
              {
                text: header.com_add_email,
                fontSize: 8,
                alignment: "right",
                margin: [0, 0, 0, 2],
                bold: true,
              },
              {
                text:
                  header.com_add_tax_id,
                fontSize: 8,
                alignment: "right",
                bold: true,
              },
            ],
          },
        ],
        margin: [0, 0, 0, 10],
      };
    },

    // ====================================================================
    // ฟังชั่นสร้างเส้นคั่นหลัง Header
    // ====================================================================
    createHeaderLine() {
      return {
        canvas: [
          {
            type: "line",
            x1: 0,
            y1: 0,
            x2: 545,
            y2: 0,
            lineWidth: 1,
          },
        ],
        margin: [0, 0, 0, 10],
      };
    },
    // ====================================================================
    // ฟังชั่นสร้างข้อมูลลูกค้าและเลขที่เอกสาร
    // ====================================================================
    createCustomerInfo(header) {

      // จัดการ address
      const addressLines = (header.addressall || "").split("\n");
      const filteredAddress = addressLines
        .filter((line) => line.trim() !== "" && line.trim() !== ",")
        .join(", ");

      // ใช้ customer_address ถ้า addressall ว่าง
      const displayAddress = filteredAddress || header.customer_address || "";

      // สร้างส่วนที่อยู่ลูกค้า
      const customerAddressStack = [];

      // บรรทัดแรก: ที่อยู่
      if (displayAddress) {
        customerAddressStack.push({
          text: displayAddress,
          fontSize: 8,
          margin: [0, 0, 0, 2],
        });
      } else {
        // ถ้าไม่มีที่อยู่ แสดง placeholder
        customerAddressStack.push({
          text: "Address Line 1, address line 1, address line 1,",
          fontSize: 8,
          margin: [0, 0, 0, 2],
        });
        customerAddressStack.push({
          text: "Address Line 2, address line 2, address line 2,",
          fontSize: 8,
          margin: [0, 0, 0, 2],
        });
        customerAddressStack.push({
          text: "Address Line 3, address line 3, address line 3,",
          fontSize: 8,
          margin: [0, 0, 0, 2],
        });
      }

      // เพิ่มเมือง รหัสไปรษณีย์ และประเทศ (ถ้ามี)
      const locationParts = [];
      if (header.province_invoice) {
        locationParts.push(header.province_invoice);
      }
      if (header.zipcode_invoice) {
        locationParts.push(header.zipcode_invoice);
      }
      if (header.country_invoice) {
        locationParts.push(header.country_invoice);
      }

      if (locationParts.length > 0) {
        customerAddressStack.push({
          text: locationParts.join(", "),
          fontSize: 8,
          margin: [0, 0, 0, 2],
        });
      }

      return {
        columns: [
          {
            width: "70%",
            stack: [
              {
                text: `To / ถึง:     ${header.customer_name ||
                  "Customer Name"}`,
                fontSize: 9,
                bold: true,
                margin: [0, 0, 0, 3],
              },
              {
                text: header.addressall,
                fontSize: 8,
                margin: [0, 0, 0, 3],
              },
              {
                text: "",
                fontSize: 8,
                margin: [0, 0, 0, 3],
              },
              {
                text: `Tax ID:     ${header.customer_taxid ||
                  "___________________________"}`,
                fontSize: 9,
                margin: [0, 0, 0, 0],
              },
            ],
          },
          {
            width: "30%",
            stack: [
              {
                text: `Date / วันที่ : ${this.formatDate2(
                  header.invoice_date
                ) || "______________"}`,
                fontSize: 9,
                alignment: "right",
                margin: [0, 0, 0, 5],
              },
              {
                text: `Invoice Ref./ อ้างอิงใบแจ้งหนี้ : ${header.period_cover ||
                  "______________"}`,
                fontSize: 9,
                alignment: "right",
              },
            ],
          },
        ],
        margin: [0, 0, 0, 15],
      };
    },


    // ====================================================================
    // ฟังชั่นสร้างตารางรายการ Description
    // ====================================================================
    createDescriptionTable(items) {
      const tableBody = [];

      // Header Row
      tableBody.push([
        {
          text: "Description / รายการ",
          fontSize: 9,
          bold: true,
          alignment: "center",
          margin: [5, 8, 5, 8],
        },
        {
          text: "Amount / จำนวนเงิน",
          fontSize: 9,
          bold: true,
          alignment: "center",
          margin: [5, 8, 5, 8],
        },
      ]);

      // Data Rows
      const minRows = 9;
      for (let i = 0; i < minRows; i++) {
        if (i < items.length) {
          const item = items[i];
          tableBody.push([
            {
              text: item.report_desc || "",
              fontSize: 9,
              margin: [5, 8, 5, 8],
            },
            {
              text: item.report_amount
                ? this.formatNumber(item.report_amount)
                : "",
              fontSize: 9,
              alignment: "right",
              margin: [5, 8, 5, 8],
            },
          ]);
        } else {
          // แถวว่าง
          tableBody.push([
            {
              text: "",
              fontSize: 9,
              margin: [5, 20, 5, 20],
            },
            {
              text: "",
              fontSize: 9,
              margin: [5, 20, 5, 20],
            },
          ]);
        }
      }

      return {
        table: {
          headerRows: 1,
          widths: ["*", 150],
          body: tableBody,
        },
        layout: {
          hLineWidth: function (i, node) {
            if (i === 0 || i === 1 || i === node.table.body.length) {
              return 1;
            }
            return 0;
          },
          vLineWidth: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return 1;
            }
            return 1;
          },
          hLineColor: function () {
            return "black";
          },
          vLineColor: function () {
            return "black";
          },
          paddingLeft: function () {
            return 0;
          },
          paddingRight: function () {
            return 0;
          },
          paddingTop: function () {
            return 0;
          },
          paddingBottom: function () {
            return 0;
          },
        },
        margin: [0, 0, 0, 0],
      };
    },

    // ====================================================================
    // ฟังชั่นสร้างส่วนสรุปยอดเงิน
    // ====================================================================
    createSummaryTable(header, textAmountEn) {
      const subTotal = header.sub_total || 0;
      const taxRate = header.tax_rate || "7.00";
      const taxAmount = header.tax_rate_amount || 0;
      const grandTotal = header.amount_total || 0;

      // ตรวจสอบว่าชื่อลูกค้าเป็นภาษาไทยหรือไม่
      const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      const isThaiCustomer = checker_th.test(header.customer_name || "");

      const summaryRows = [];

      // แถว Sub Total
      summaryRows.push([
        {
          text: "Sub Total / รวมเป็นเงิน",
          fontSize: 9,
          bold: true,
          alignment: "left",
          margin: [5, 5, 5, 5],
        },
        {
          text: this.formatNumber(subTotal),
          fontSize: 9,
          alignment: "right",
          margin: [5, 5, 5, 5],
        },
      ]);

      // แถว Value Added Tax
      if (header.company_inv != "L") {
        summaryRows.push([
          {
            text: `Value Added Tax / ภาษีมูลค่าเพิ่ม (${taxRate}%)`,
            fontSize: 9,
            bold: true,
            alignment: "left",
            margin: [5, 5, 5, 5],
          },
          {
            text: this.formatNumber(taxAmount),
            fontSize: 9,
            alignment: "right",
            margin: [5, 5, 5, 5],
          },
        ]);
      }
      // แถว Grand Total
      summaryRows.push([
        {
          text: "Grand Total / ยอดรวม",
          fontSize: 9,
          bold: true,
          alignment: "left",
          margin: [5, 5, 5, 5],
        },
        {
          text: this.formatNumber(grandTotal),
          fontSize: 9,
          bold: true,
          alignment: "right",
          margin: [5, 5, 5, 5],
        },
      ]);

      // แถวแสดงยอดรวมเป็นตัวหนังสือ - แสดงตามภาษาของชื่อลูกค้า
      let amountText = "";
      if (isThaiCustomer) {
        // ลูกค้าเป็นภาษาไทย - แสดงเฉพาะภาษาไทย
        amountText = `${textAmountEn || ""}`;
      } else {
        // ลูกค้าเป็นภาษาอังกฤษ - แสดงทั้งภาษาอังกฤษและสกุลเงิน
        amountText = `(${textAmountEn || ""}) ${this.currency_show || "THB"}`;
      }

      summaryRows.push([
        {
          text: amountText,
          fontSize: 9,
          alignment: "center",
          colSpan: 2,
          fillColor: "#d8d8d8",
          margin: [5, 5, 5, 5],
        },
        {},
      ]);

      return {
        table: {
          widths: ["*", 150],
          body: summaryRows,
        },
        layout: {
          hLineWidth: function (i, node) {
            if (i === 0) {
              return 0; // ไม่วาดเส้นบนสุด ใช้เส้นล่างของตาราง Description แทน
            }
            return 1;
          },
          vLineWidth: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return 1;
            }
            return 1;
          },
          hLineColor: function () {
            return "black";
          },
          vLineColor: function () {
            return "black";
          },
          paddingLeft: function () {
            return 0;
          },
          paddingRight: function () {
            return 0;
          },
          paddingTop: function () {
            return 0;
          },
          paddingBottom: function () {
            return 0;
          },
        },
        margin: [0, 0, 0, 15],
      };
    },

    // ====================================================================
    // ฟังชั่นสร้างส่วนลายเซ็น
    // ====================================================================
    createSignatureBox() {
      return {
        columns: [
          {
            width: "50%",
            text: "",
          },
          {
            width: "50%",
            table: {
              widths: ["*"],
              body: [
                [
                  {
                    stack: [
                      {
                        text: "",
                        margin: [0, 0, 0, 35],
                      },
                      {
                        canvas: [
                          {
                            type: "line",
                            x1: 30,
                            y1: 0,
                            x2: 210,
                            y2: 0,
                            lineWidth: 1,
                          },
                        ],
                        margin: [0, 0, 0, 5],
                      },
                      {
                        text: "Authorized Signature / ผู้มีอำนาจลงนาม",
                        fontSize: 9,
                        alignment: "center",
                        margin: [0, 0, 0, 10],
                      },
                      {
                        text: "Date/วันที่ _______________________",
                        fontSize: 9,
                        alignment: "center",
                        margin: [0, 0, 0, 10],
                      },
                    ],
                    margin: [5, 5, 5, 5],
                  },
                ],
              ],
            },
            layout: {
              hLineWidth: function () {
                return 1;
              },
              vLineWidth: function () {
                return 1;
              },
              hLineColor: function () {
                return "black";
              },
              vLineColor: function () {
                return "black";
              },
            },
          },
        ],
        margin: [0, 0, 0, 15],
      };
    },

    // ====================================================================
    // ฟังชั่นสร้างเอกสาร PDF หลัก
    // ====================================================================
    generateCreditNotePDF(header, items, textAmountEn) {
      const mainContent = [];

      mainContent.push(this.createTopTitle(header));
      mainContent.push(this.createHeader(header));
      mainContent.push(this.createHeaderLine());
      mainContent.push(this.createCustomerInfo(header));
      mainContent.push(this.createDescriptionTable(items));
      mainContent.push(this.createSummaryTable(header, textAmountEn));
      mainContent.push(this.createSignatureBox());

      return mainContent;
    },

    // ====================================================================
    // ฟังชั่นสร้าง Document Definition สำหรับ pdfMake
    // ====================================================================
    generateDocDefinition(header, items, textAmountEn) {
      const mainContent = this.generateCreditNotePDF(
        header,
        items,
        textAmountEn
      );

      const docDefinition = {
        pageSize: "A4",
        pageMargins: [25, 25, 25, 25],
        content: mainContent,
        defaultStyle: {
          font: "Sarabun",
          fontSize: 10,
        },
      };

      return docDefinition;
    },

    // ====================================================================
    // ฟังชั่นดูตัวอย่าง PDF
    // ====================================================================
    async previewCreditNotePDF() {
      try {
        await this.waitForPdfMakeReady();

        // ✅ ใช้ข้อมูลจาก property ที่มีอยู่แล้วใน component
        const header = this.print_header;
        const items = this.extractItems();
        const textAmountEn = this.textamount_total_en;

        const docDefinition = this.generateDocDefinition(
          header,
          items,
          textAmountEn
        );
        // pdfMake.createPdf(docDefinition).open();

        pdfMake.createPdf(docDefinition).getBlob((blob) => {
          this.pdfBlob = blob;
          this.dialogPDF = true;
          this.$hideLoader();
        });



      } catch (error) {
        console.error("❌ เกิดข้อผิดพลาด:", error);
        this.$swal.fire("Error", "เกิดข้อผิดพลาดในการสร้าง PDF", "error");
      }
    },

    // ====================================================================
    // ฟังชั่นดึง items จาก datashowAll
    // ====================================================================
    extractItems() {
      const datashowAll = this.datashowAll || [];
      const allItems = [];

      datashowAll.forEach((group) => {
        if (Array.isArray(group)) {
          group.forEach((item) => {
            allItems.push(item);
          });
        }
      });

      return allItems;
    },

    async loadCustomer() {
      const result = await api.getAllCustomerListactiveCompany({
        params: {
          company_id: localStorage.getItem(server.COMPANYID),
        },
      });

      this.customer = result.data;

      // const resultlist = await api.getCustomers();
      // this.customerNameList = result.data[0];
      this.customerNameList = result.data;
    },
    async loaddataEditCreditNote() {
      const res_hresult = await api.billing_expense_getdataByIdInvoice_H(this.$route.params.id);
      const res_docref_so = await api.billing_expense_getRef_TypeCNById(this.$route.params.id);
      const res_inv_so = await api.billing_expense_getdataByIdInv_SO(this.$route.params.id);
      this.desserts = res_inv_so.data;

      this.vat_type = res_hresult.data[0].vat_type;
      if (this.vat_type == "E") {
        this.vat_type_show = "Exclude Vat";
      } else if (this.vat_type == "I") {
        this.vat_type_show = "Include Vat";
      } else {
        return;
      }

      if (res_hresult.data[0].status == "Credit Note") {
        this.disabledstatus = true;
      }

      // company L ไม่คิด VAT
      if (res_hresult.data[0].company_inv == "L") {
        this.vatCal = 0;
        this.vat = "0.00";
      }

      // คำนวณ Total / VAT / Grand total จากรายการ
      await this.loaddefaultvat();

      this.addIteminv_h.period_cover = res_hresult.data[0].period_cover;

      this.showinv_id = res_docref_so.data[0].id_inv_h;
      this.showinv_no = res_docref_so.data[0].inv_id;
      this.showamount = res_docref_so.data[0].sub_total;
      this.customer_code = res_docref_so.data[0].customerid;
      this.cus_id = res_docref_so.data[0].customerid;
    },
    async loaddefaultvat() {

      this.sumtotal = 0;

      this.desserts.forEach((item, index) => {

        item.no = index + 1;

        const unit =
          item.unit !== undefined &&
            item.unit !== null &&
            item.unit !== ''
            ? Number(stringcommatonumber(String(item.unit)))
            : null;

        const price =
          item.priceperunit !== undefined &&
            item.priceperunit !== null &&
            item.priceperunit !== ''
            ? Number(stringcommatonumber(String(item.priceperunit)))
            : null;

        let amount = null;

        if (typeof unit === 'number' && typeof price === 'number' && !isNaN(unit) && !isNaN(price)) {
          amount = unit * price;
          this.sumtotal += amount;
        }

        // format กลับเฉพาะที่มีค่า
        if (unit !== null) {
          item.unit = tolocalestringnumber(unit);
        }

        if (price !== null) {
          item.priceperunit = tolocalestringnumber(price);
        }

        if (amount !== null) {
          item.amount = tolocalestringnumber(amount.toFixed(2));
        }

      });

      if (this.vat_type == "E") {
        this.sumtotal = this.sumtotal.toFixed(2);
        this.vatCalSum = (this.sumtotal * (this.vatCal / 100)).toFixed(2);
        this.sumGrandTotal = Number(this.sumtotal) + Number(this.vatCalSum);
      } else if (this.vat_type == "I") {
        this.sumGrandTotal = this.sumtotal.toFixed(2);
        this.sumtotal = (
          this.sumGrandTotal *
          (100 / (100 + this.vatCal))
        ).toFixed(2);
        this.vatCalSum = Number(this.sumGrandTotal) - Number(this.sumtotal);
      } else {
        return;
      }

      this.sumtotal = tolocalestringnumber(this.sumtotal);
      this.vatCalSum = tolocalestringnumber(this.vatCalSum);
      this.sumGrandTotal = tolocalestringnumber(this.sumGrandTotal);
    },
    save() {
      // alert("texttable")
      if (this.editedItem.description == "") {
        // alert("กรุณากรอก Description/Service ");
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "กรุณากรอก Description/Service",
          "text-h5 red--text text-center"
        );
        this.$refs["txtDescription"].focus();
        return;
      }

      if (
        this.editedItem.unit == undefined ||
        this.editedItem.unit == "0" ||
        this.editedItem.unit == 0
      ) {
        // alert("กรุณากรอกจำนวน");
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "กรุณากรอกจำนวน Qty",
          "text-h5 red--text text-center"
        );
        this.$refs["txtunit"].focus();
        return;
      }

      if (this.editedItem.unit < 0) {
        // alert("กรุณากรอกจำนวน");
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "จำนวน Qty ต้องมากกว่า 0",
          "text-h5 red--text text-center"
        );
        this.$refs["txtunit"].focus();
        return;
      }

      if (
        this.editedItem.priceperunit == undefined ||
        this.editedItem.priceperunit == "0" ||
        this.editedItem.priceperunit == 0
      ) {
        // alert("กรุณากรอกจำนวนเงินต่อหน่วย");
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "กรุณากรอกจำนวน Price Per Unit",
          "text-h5 red--text text-center"
        );
        this.$refs["txtPricePerUnit"].focus();
        return;
      }

      if (this.editedItem.priceperunit < 0) {
        // alert("กรุณากรอกจำนวน");
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "จำนวน Price Per Unit ต้องมากกว่า 0",
          "text-h5 red--text text-center"
        );
        this.$refs["txtunit"].focus();
        return;
      }
      // if (this.editedItem.amount == 0 ) {
      //   alert("กรุณากรอกจำนวนเงิน");
      //   this.$refs["txtAmount"].focus();
      //   return;
      // }

      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.sumtotal = 0;
      this.sumGrandTotal = 0;
      // this.desserts.forEach((item,index) => {
      //     item.no = index+1;
      //     item.amount =  item.unit*item.PricePerUnit;
      //     this.sumtotal += parseFloat(item.amount);

      //  })
      this.desserts.forEach((item, index) => {
        item.no = index + 1;
        item.unit = stringcommatonumber(item.unit.toString());
        item.priceperunit = stringcommatonumber(item.priceperunit.toString());
        item.amount = parseFloat(item.unit * item.priceperunit).toFixed(2);
        this.sumtotal += parseFloat(item.amount, 10);
        item.unit = tolocalestringnumber(item.unit);
        item.priceperunit = tolocalestringnumber(item.priceperunit);
        item.amount = tolocalestringnumber(item.amount);
      });


      if (this.vat_type == "E") {
        this.sumtotal = this.sumtotal.toFixed(2);
        this.vatCalSum = (this.sumtotal * (this.vatCal / 100)).toFixed(2);
        this.sumGrandTotal = Number(this.sumtotal) + Number(this.vatCalSum);
      } else if (this.vat_type == "I") {
        this.sumGrandTotal = this.sumtotal.toFixed(2);
        this.sumtotal = (
          this.sumGrandTotal *
          (100 / (100 + this.vatCal))
        ).toFixed(2);
        this.vatCalSum = Number(this.sumGrandTotal) - Number(this.sumtotal);
      } else {
        return;
      }

      this.sumtotal = tolocalestringnumber(this.sumtotal);
      this.vatCalSum = tolocalestringnumber(this.vatCalSum);
      this.sumGrandTotal = tolocalestringnumber(this.sumGrandTotal);
      this.close();
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },

    async showCusName() {
      //alert(this.cus_id)

      const result = await api.getCustomersById(this.cus_id);
      // this.customerNameList = result.data[0];
      this.customerList = result.data;
      this.customer_code = this.cus_id;
      this.vatCal = parseInt(this.customerList[0].vat);
      this.vat = this.customerList[0].vat;

    },
    async showCode() {


      const result = await api.getCustomersById(this.customer_code);
      // this.customerNameList = result.data[0];
      this.customerList = result.data;
      this.cus_id = this.customer_code;
      this.vatCal = parseInt(this.customerList[0].vat);
      this.vat = this.customerList[0].vat;
    },
    async saveinvDraftandSubmit(mode) {
      if (mode == "Submit") {
        const resCheckDoc = await api.checkDocRunning(
          "Credit Note",
          localStorage.getItem(server.COMPANYID)
        );
        if (resCheckDoc.status == 200) {
          if (!resCheckDoc.data[0].resCheckDoc) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Information Saved",
              "Please kindly check the value of document running.",
              "text-h5 red--text text-center"
            );
            return;
          }
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "ไม่สามารถบันทึกได้",
            "text-h5 red--text text-center"
          );
          return;
        }
      }


      if (
        !this.addIteminv_h.period_cover ||
        this.addIteminv_h.period_cover == ""
      ) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please enter Reason CN Data",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (
        parseFloat(stringcommatonumber(this.sumtotal.toString())) >
        parseFloat(this.showamount)
      ) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "ไม่สามารถลดหนี้มากกว่าการตั้งหนี้ได้",
          "text-h5 red--text text-center"
        );
        return;
      }
      // return;
      this.$showLoader();
      let add_hresult = [];
      this.addIteminv_h.tax_rate = stringcommatonumber(this.vatCal.toString());
      this.addIteminv_h.sub_total = stringcommatonumber(
        this.sumtotal.toString()
      );
      this.addIteminv_h.amount_total = stringcommatonumber(
        this.sumGrandTotal.toString()
      );
      if (mode == "Draft") {
        this.addIteminv_h.status = 1;
        add_hresult = await api.billing_expense_updateInvoice_H(
          this.$route.params.id,
          this.addIteminv_h
        );
      } else if (mode == "Submit") {
        this.addIteminv_h.status = 2;
        add_hresult = await api.billing_expense_updateInvoice_H_Geninv_id(
          this.$route.params.id,
          this.addIteminv_h
        );
      } else {
      }


      if (add_hresult.status == 200 || add_hresult.status == 201) {
        await api.billing_expense_deleteInv_SO(this.$route.params.id);
        this.desserts.forEach(async (x, index) => {
          this.addinv_so.inv_hid = this.$route.params.id;
          this.addinv_so.so_seq = index + 1;
          this.addinv_so.item_name = x.description;
          this.addinv_so.item_qty = x.unit;
          this.addinv_so.item_price = stringcommatonumber(
            x.priceperunit.toString()
          );
          this.addinv_so.item_line_amt = stringcommatonumber(
            x.amount.toString()
          );
          await api.billing_expense_addInv_SO(this.addinv_so);
        });

        this.addinv_docref_cn.inv_hid = this.$route.params.id;
        this.addinv_docref_cn.ref_id = this.showinv_id;

        await api.billing_expense_delete_docrefCN(this.$route.params.id);
        const add_docrefresult = await api.billing_expense_addInv_Docref(this.addinv_docref_cn);

        if (add_docrefresult.status == 200 || add_docrefresult.status == 201) {
          this.$hideLoader();
          this.$store.state.global_push_dialog = true;
          this.setupAlertDialogPush(
            true,
            "Information Saved",
            "Information successfully saved",
            "text-h5 green--text text-center",
            "/reloadpage"
          );
        }
      } else {
        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "ไม่สามารถบันทึกได้",
          "text-h5 red--text text-center"
        );
      }
    },
    closeDeletefrom() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeDelete() {
      this.sumtotal = 0;
      this.sumGrandTotal = 0;

      this.desserts.forEach((item, index) => {
        item.no = index + 1;
        this.sumtotal += Number(stringcommatonumber(item.amount));
      });

      if (this.vat_type == "E") {
        this.sumtotal = this.sumtotal.toFixed(2);
        this.vatCalSum = (this.sumtotal * (this.vatCal / 100)).toFixed(2);
        this.sumGrandTotal = Number(this.sumtotal) + Number(this.vatCalSum);
      } else if (this.vat_type == "I") {
        this.sumGrandTotal = this.sumtotal.toFixed(2);
        this.sumtotal = (
          this.sumGrandTotal *
          (100 / (100 + this.vatCal))
        ).toFixed(2);
        this.vatCalSum = Number(this.sumGrandTotal) - Number(this.sumtotal);
      } else {
        return;
      }

      this.sumtotal = tolocalestringnumber(this.sumtotal);
      this.vatCalSum = tolocalestringnumber(this.vatCalSum);
      this.sumGrandTotal = tolocalestringnumber(this.sumGrandTotal);

      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },

    initialize() { },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      this.desserts.splice(this.editedIndex, 1);
      this.closeDelete();
    },
    previewImage: function (event) {
      var input = event.target;
      if (input.files) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.preview = e.target.result;
        };
        this.image = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
    },
    previewMultiImage: function (event) {
      var input = event.target;
      var count = input.files.length;
      var index = 0;
      if (input.files) {
        while (count--) {
          var reader = new FileReader();
          reader.onload = (e) => {
            this.preview_list.push(e.target.result);
          };
          if (input.files[index].type.split("/")[0] === "image") {
            this.image_list.push(input.files[index]);
            reader.readAsDataURL(input.files[index]);
          }
          index++;
        }
      }

    },
    reset: function () {
      this.image = null;
      this.preview = null;
      this.image_list = [];
      this.preview_list = [];
    },
    clickremoveimage(index) {
      this.indeximage = index;
      this.dialogDeleteimage = true;
    },
    async removeimage(index) {
      this.preview_list.splice(this.indeximage, 1);
      this.image_list.splice(this.indeximage, 1);

      this.dialogDeleteimage = false;
    },
    closeDeleteimage() {
      this.indeximage = null;
      this.dialogDeleteimage = false;
    },
    closeSaveDraft() { },
  },
  async beforeCreate() {

    this.$store.state.navMenu = true;

    // this.showdefaultsignature();
  },
  async created() {
    // this.showdefaultsignature();
  },
};
</script>

<style scoped>
.heightsize55formadvance {
  height: 55px;
}

body {
  background: rgb(204, 204, 204);
}

.fontweight700 {
  font-weight: 700;
}

.page {
  background: white;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
}

.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

.page[size="A4"][layout="landscape"] {
  width: 29.7cm;
  height: 21cm;
}

.page[size="A3"] {
  width: 29.7cm;
  height: 42cm;
}

.page[size="A3"][layout="landscape"] {
  width: 42cm;
  height: 29.7cm;
}

.page[size="A5"] {
  width: 14.8cm;
  height: 21cm;
}

.page[size="A5"][layout="landscape"] {
  width: 21cm;
  height: 14.8cm;
}

@page {
  size: 7in 9.25in;
  margin: 27mm 16mm 27mm 16mm;
}

page {
  position: relative;
  background: white;
  display: block;
  margin: 0 auto;
  line-height: 1.5;
  /* margin-bottom: 0.5cm; */
  border: 1px solid;
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
  font-family: "Roboto", sans-serif;
}

page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

page[size="A4"][layout="portrait"] {
  width: 29.7cm;
  height: 21cm;
}

@media print {

  body,
  page {
    margin: 0;
    box-shadow: 0;
  }

  html,
  body {
    width: 210mm;
    height: 297mm;
  }
}

.page {
  display: inline-block;
  position: relative;
  height: 297mm;
  width: 210mm;
  font-size: 12pt;
  margin: 2em auto;
  padding: calc(var(--bleeding) + var(--margin));
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
  background: white;
}

@media screen {
  .page::after {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: calc(100% - var(--bleeding) * 2);
    height: calc(100% - var(--bleeding) * 2);
    margin: var(--bleeding);
    /* outline: thin dashed black; */
    pointer-events: none;
    z-index: 9999;
  }
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.btnuploadfile {
  border: 2px solid;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred {
  width: 100%;
  background-color: #9e3b1b;
  color: white;
}

.v-btn:not(.v-btn--round).v-size--default.buttonwhite {
  width: 100%;
  background-color: #f5f5f5;
  color: black;
}

h3 {
  font-size: 1.17em;
}

h4 {
  font-size: 1em;
}

.test {
  border-style: double;
}

.borderblack {
  border-style: solid;
  border-width: thin;
}

.mt-50 {
  margin-top: 50px;
}

.mb-50 {
  margin-bottom: 50px;
}

.btn-light {
  color: #333;
  background-color: #fafafa;
  border-color: #ddd;
}

@media (min-width: 768px) {
  .wmin-md-400 {
    min-width: 400px !important;
  }
}

.btn-primary {
  color: #fff;
  background-color: #2196f3;
}

.btn-labeled>b {
  position: absolute;
  top: -1px;
  background-color: blue;
  display: block;
  line-height: 1;
  padding: 0.62503rem;
}

.alignleft {
  float: left;
}

.alignright {
  float: right;
}

.aligncenter {
  text-align: center;
}

.captionreport {
  font-size: 0.85rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}

.caption {
  font-size: 0.75rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}

.captionhtable {
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}

.rowprpo {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  margin-right: -12px;
  margin-left: -12px;
}

.colprpo {
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  max-width: 100%;
}

.col-md-1report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 8.333333333333333%;
  flex: 0 0 8.333333333333333%;
  max-width: 8.333333333333333%;
}

.col-md-2report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 16.66666666666667%;
  flex: 0 0 16.66666666666667%;
  max-width: 16.66666666666667%;
}

.col-md-3report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 25%;
}

.col-md-4report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 33.33333333333333%;
  flex: 0 0 33.33333333333333%;
  max-width: 33.33333333333333%;
}

.col-md-5report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 41.66666666666667%;
  flex: 0 0 41.66666666666667%;
  max-width: 41.66666666666667%;
}

.col-md-6report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.col-md-7report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 58.33333333333333%;
  flex: 0 0 58.33333333333333%;
  max-width: 58.33333333333333%;
}

.col-md-8report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 66.66666666666667%;
  flex: 0 0 66.66666666666667%;
  max-width: 66.66666666666667%;
}

.col-md-9report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 75%;
  flex: 0 0 75%;
  max-width: 75%;
}

.col-md-10report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 83.33333333333333%;
  flex: 0 0 83.33333333333333%;
  max-width: 83.33333333333333%;
}

.col-md-11report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 91.66666666666667%;
  flex: 0 0 91.66666666666667%;
  max-width: 91.66666666666667%;
}

.col-md-12report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}

.mt-5prpo {
  margin-top: -5px !important;
}

.mt-30prpo {
  margin-top: -30px !important;
}

.mt30 {
  margin-top: 30px !important;
}

.mt20 {
  margin-top: 20px !important;
}

.mt10 {
  margin-top: 10px !important;
}

.mt25 {
  margin-top: 25px !important;
}

.mt-25prpo {
  margin-top: -25px !important;
}

.mr30prpo {
  margin-right: 30px !important;
}

.ml30prpo {
  margin-left: 30px !important;
}

.ml2prpo {
  margin-left: 2px !important;
}

.ml10prpo {
  margin-left: 10px !important;
}

.ml-40prpo {
  margin-left: -40px !important;
}

.borderblockpr {
  border: 1px solid black;
  width: 300px;
  height: 80px;
  /* background: white; */
  /* box-sizing: border-box; */
  display: inline-block;
}

.col-md-4pr {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 30%;
  flex: 0 0 30%;
  max-width: 30%;
}

.col-md-8pr {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 70%;
  flex: 0 0 70%;
  max-width: 70%;
}

.col-md-4prrd {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.col-md-8prrd {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.textalignleft {
  text-align: left;
}

.textalignright {
  text-align: right;
}

.textaligncenter {
  text-align: center;
}

table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
  /* border: 1px solid black; */
}

.prbordertop {
  border-top: 1px solid black;
}

.prborderbottom {
  border-bottom: 1px solid black;
}

.prbordertop2pxhtable {
  padding-top: 8px;
  /* border-top: 1px solid black; */
}

.prborderbottom2pxhtable {
  padding-bottom: 8px;
  border-bottom: 1px solid black;
}

td {
  /* border: 1px solid black; */
}

td.tdborder-top {
  border-top: 1px solid black;
}

td.tdborder-right {
  border-right: 1px solid black;
}

td.tdborder-left {
  border-left: 1px solid black;
}

td.tdborder-bottom {
  border-bottom: 1px solid black;
}

th {
  /* border: 1px solid black; */
}

th.thborder-top {
  border-top: 1px solid black;
}

th.thborder-right {
  border-right: 1px solid black;
}

th.thborder-left {
  border-left: 1px solid black;
}

th.thborder-bottom {
  border-bottom: 1px solid black;
}

.width15 {
  word-wrap: break-word;
  width: 15%;
}

.width10 {
  word-wrap: break-word;
  width: 10%;
}

.width20 {
  word-wrap: break-word;
  width: 20%;
}

.width30 {
  word-wrap: break-word;
  width: 30%;
}

.width40 {
  word-wrap: break-word;
  width: 40%;
}

.width50 {
  word-wrap: break-word;
  width: 50%;
}

.width60 {
  word-wrap: break-word;
  width: 60%;
}

.width70 {
  word-wrap: break-word;
  width: 70%;
}

.width75 {
  word-wrap: break-word;
  width: 75%;
}

.width80 {
  word-wrap: break-word;
  width: 80%;
}

.width85 {
  word-wrap: break-word;
  width: 85%;
}

.width90 {
  word-wrap: break-word;
  width: 90%;
}

.width100 {
  word-wrap: break-word;
  width: 100%;
}

@media print {

  /*
          body.A3.landscape { width: 420mm }
          body.A3, body.A4.landscape { width: 297mm }
          body.A4, body.A5.landscape { width: 210mm }
          body.A5 { width: 148mm }*/
  .printonly {
    display: block;
  }

  .noprint {
    display: none;
  }

  .A3.landscape {
    width: 420mm;
  }

  .A3,
  .A4.landscape {
    width: 297mm;
  }

  .A4,
  .A5.landscape {
    width: 210mm;
  }

  .A5 {
    width: 148mm;
  }
}

footer {
  bottom: 0;
  color: #000;
  padding-top: 3mm;
  padding-bottom: 5mm;
}

header,
footer {
  /* position: fixed; */
  left: 0;
  right: 0;
  background-color: #ccc;
  padding-right: 1.5cm;
  padding-left: 1.5cm;
}

.footerprpo {
  position: absolute;
  bottom: 10px;
  width: 100%;
}

.borderauto {
  border: 1px solid;
  margin: -1px;
}

.bordersignature {
  height: 110px;
  border: 1px solid;
  margin: -1px;
}

.fixfourrow {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  height: 80px;
  overflow: hidden;
  text-align: left;
}

.fixthreerow {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  height: 60px;
  overflow: hidden;
  text-align: left;
}

.fixtworow {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 40px;
  overflow: hidden;
  text-align: left;
}

.fixonerow {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 20px;
  overflow: hidden;
  text-align: left;
}

.fixonerowcenter {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 20px;
  overflow: hidden;
  text-align: center;
}

.fontsize10 {
  font-size: 10px;
}

.fontsize12 {
  font-size: 12px;
}

.fontsize13 {
  font-size: 12px;
}

.borderwidththin {
  border-width: thin;
  border-color: darkgray;
}

.titledatadetailintable {
  font-weight: bold;
  text-decoration: underline;
}

.paddingleftintable {
  padding-left: 10px;
}

.paddingrightintable {
  padding-right: 10px;
}
</style>
